module.exports = __webpack_public_path__ + "static/8-3244764a568d5a7e74053cec256c6e6b.jpeg";